import Stack from "@mui/joy/Stack";
import Typography from "@mui/joy/Typography";
import PaymentButton from "components/PaymentButton2";
import useGetTaskTitleFromTaskKey from "hooks/useGetTaskTitleFromTaskKey";

export default function PaymentHeader() {
  const title = useGetTaskTitleFromTaskKey("payment");

  return (
    <Stack
      direction={"column"}
      sx={{
        backgroundColor: "background.level1",
        height: "var(--StickyHeader-height)",

        borderBottom: 1,
        borderColor: "background.level3",
      }}
    >
      <Stack
        direction={"row"}
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        sx={{
          flex: 1,
          height: "100%",
          px: "4px",
        }}
      >
        <Stack direction="row" alignItems={"center"} spacing={1} flexGrow={1}>
          <Typography
            level="title-lg"
            flexGrow={1}
            sx={{
              flex: 1,
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: "1",
              WebkitBoxOrient: "vertical",
            }}
          >
            {title}
          </Typography>
        </Stack>

        <Stack
          direction="row"
          alignItems={"center"}
          spacing={1.5}
          sx={{ py: 0 }}
        >
          <PaymentButton />
        </Stack>
      </Stack>
    </Stack>
  );
}
